<script setup lang="ts">
import SelectCityModal from "./SelectCityModal.vue";
import { computed, onMounted, ref } from "vue";
import { IconMapPinFill } from "@packages/icon-library";
import HeaderCityAutocomplete from "./HeaderCityAutocomplete.vue";
import { userLocationStore } from "@/modules/user-location";
import { useRoute } from "vue-router";

const showSelectCityModal = ref(false);
const showCityAutocomplete = ref(false);
const locationStore = userLocationStore();
const systemCity = computed(() => locationStore.city?.title);
const route = useRoute();

const changeUserCity = () => {
  showSelectCityModal.value = true;
  showCityAutocomplete.value = false;
};

onMounted(() => {
  if (!localStorage.userCity && route.name !== "OrderPayment") {
    showCityAutocomplete.value = true;
  }
});
</script>

<template>
  <SelectCityModal
    v-if="showSelectCityModal"
    @close="showSelectCityModal = false"
  />

  <div class="header-location">
    <button type="button" class="header-item" @click="changeUserCity">
      <IconMapPinFill /> {{ systemCity }}
    </button>

    <HeaderCityAutocomplete
      v-if="showCityAutocomplete"
      @change="changeUserCity"
      @close="showCityAutocomplete = false"
    />
  </div>
</template>

<style scoped lang="scss">
.header-location {
  position: relative;
}

.city-autocomplete {
  position: absolute;

  &__actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: calc($base-space * 3);
  }
}
</style>
